import React from 'react'

import { Loader } from '@components/Loader'
import { useFindSiteAreas } from '@hooks/catalogs/areas'
import { useFindSiteAssignees } from '@hooks/catalogs/assignees'
import { useFindSiteLocations } from '@hooks/catalogs/locations'
import { useFindOperationPosts } from '@hooks/catalogs/operationPosts'
import { useFindSitePlantSections } from '@hooks/catalogs/plantSections'
import { useFindSiteProjects } from '@hooks/catalogs/projects'
import { useFindSiteResources } from '@hooks/catalogs/resources'
import { useFindSiteSupervisors } from '@hooks/catalogs/supervisors'

import { FiltersContainer } from './Container'

export function FiltersLoader() {
  const { isLoading: isLoadingAreas } = useFindSiteAreas()
  const { isLoading: isLoadingLocations } = useFindSiteLocations()
  const { isLoading: isLoadingResources } = useFindSiteResources()
  const { isLoading: isLoadingSupervisors } = useFindSiteSupervisors()
  const { isLoading: isLoadingPlantSections } = useFindSitePlantSections()
  const { isLoading: isLoadingPosts } = useFindOperationPosts()
  const { isLoading: isLoadingAssignees } = useFindSiteAssignees()
  const { isLoading: isLoadingProjects } = useFindSiteProjects()

  const isLoading =
    isLoadingAreas &&
    isLoadingLocations &&
    isLoadingResources &&
    isLoadingSupervisors &&
    isLoadingPlantSections &&
    isLoadingPosts &&
    isLoadingAssignees &&
    isLoadingProjects

  return <>{isLoading ? <Loader /> : <FiltersContainer />}</>
}
